webpackJsonp([135580260768175],{

/***/ 1800:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"HfdApplicationFee","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":"Null when the invoice cannot be sent.","isDeprecated":false,"name":"amountCents","type":{"kind":"SCALAR","name":"Int","ofType":null}},{"args":[],"deprecationReason":null,"description":"Null when the invoice can be sent.","isDeprecated":false,"name":"error","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":"The application fee an invoice carries, or why it cannot be sent to HFD.","enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-hfd-application-fee-921dda2ee310910cf248.js